import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {update} from "../../../app/setters/update.js";

export const usePoprosOdblokowanieKp = (setErrors) => {

    const queryClient = useQueryClient();
    const dispatch = useDispatch()
    return useMutation({
        mutationFn: (data) => update(`/rejestr/prosba-odblokuj`, data),
        onError: (err) => {
            if (typeof setErrors === 'function') {
                setErrors(err.response.data.errors);
            }
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },

        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}
